import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  Input,
  AfterViewInit,
  ViewChild
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  Multiselect,
  MultiselectItem,
  MultiselectItems,
  MultiselectSettings,
  ToastMessage
} from '../../core/interfaces/admin.interface';
import { MultiselectService } from '../../core/services/multiselect.service';
import {NgSelectComponent} from "@ng-select/ng-select";
import {companyId} from "../../core/classes/Utils";

@Component({
  selector: 'app-company-select',
  templateUrl: './company-select.component.html',
  styleUrls: ['./company-select.component.scss']
})
export class CompanySelectComponent implements OnInit {
  @ViewChild("select")
  select: NgSelectComponent

  @Input() clearable = true;
  @Input() asFilter = false; // Multiple items can be selected when filtering, otherwise one at a time
  @Input() defaultCompany: number; // Id of the default company that has to be selected

  @Output() companySelect = new EventEmitter<number | number[]>();
  @Output() itemSelection = new EventEmitter<MultiselectItem>();
  @Output() companySelection = new EventEmitter<CmpnSelection>();
  @Output() loaded = new EventEmitter<MultiselectItem[]>();

  _readonly: boolean = false

  @Input()
  selectedCompanies: number[] = [];

  multiselectItems: MultiselectItems = {
    company: []
  };

  multiselectSettings_base: MultiselectSettings = {
    singleSelection: false,
    text: "Select company",
    searchPlaceholderText: "Search",
    selectAllText: "Select All",
    unSelectAllText: "UnSelect All",
    enableSearchFilter: true,
    classes: "",
    badgeShowLimit: 1,
  };
  multiselectSettings_Company: MultiselectSettings = Object.assign({}, this.multiselectSettings_base);

  toastMessage: ToastMessage = {
    elementList: null,
    multiselect: null,
    toggle_active_ok: null,
    toggle_active_er: null,
    duplicate_ok: null,
    duplicate_er: null,
    delete_er: null,
    delete_ok: null,
    invite_ok: null,
    invite_er: null
  };

  processing: any = {
    list: false,
    translation: false,
  };

  constructor(
    private multiselectService: MultiselectService,
    private translate: TranslateService,
    private cdRef: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    this.loadAlertTranslation();
    this.setMultiselectSettings();
    await this.multiselectService.loadMultiselectItems(this.multiselectItems, Multiselect.COMPANY, this.toastMessage);
    this.initializeData();
    this.select.itemsList.setItems(this.multiselectItems.company) // it should not be necessary!!!, but without the does no get filled!!
    this.loaded.emit(this.multiselectItems.company);
    this.select.readonly = this._readonly
  }

  reset() {
    this.initializeData();
  }

  private initializeData() {
    if (this.defaultCompany) {
      if(this.asFilter)
        this.selectedCompanies = this.multiselectItems.company ? this.multiselectItems.company.filter((v: MultiselectItem) => v.id === this.defaultCompany).map(n=>n.id): [];
      else
        this.selectedCompanies = this.multiselectItems.company ? this.multiselectItems.company
            .map(n=>n.id).find((id: number) => id === this.defaultCompany) : [];
    } else
      this.selectedCompanies = [];
  }

  loadAlertTranslation(): void {
    this.translate.stream("toast").subscribe((tr) => {
      this.toastMessage.elementList = tr.element;
      this.toastMessage.multiselect = tr.multiselect;
    });
  }

  setMultiselectSettings() {
    this.cdRef.detach();
    this.multiselectSettings_Company.singleSelection = !this.asFilter;
    this.multiselectService.applyFilterTranslationText(Multiselect.COMPANY, this.multiselectSettings_Company, false, this.processing);
    this.cdRef.reattach();
  }

  /** Method emitted on value selection, that returns the array of company ids when used as filter, or the single company id on creation */
  manageCompanyChange(): void {
      //const currentValues = Array.from(this.selectedCompanies, (c: any) => c.id);
    //this.companySelect.emit(currentValues.length <= 1 ? currentValues[0] : currentValues);
    console.log(`comp-sel->manageCompanyChange->1->${this.counter}`)
    this.companySelect.emit(this.selectedCompanies);
    this.companySelection.emit({
      id: companyId(this.selectedCompanies),
      company: null,
      counter: ++this.counter.notify
    });
    console.log(`comp-sel->manageCompanyChange->2->${this.counter}`)
    if(this.selectedCompanies == null || this.selectedCompanies.length < 1) {
      console.log(`comp-sel->manageCompanyChange->3->${this.counter}`)
      this.itemSelection.emit(null);
      console.log(`comp-sel->manageCompanyChange->4->${this.counter}`)
    }
    else {
      const company =
          this.multiselectItems.company.find(c => c.id == this.selectedCompanies)
      this.itemSelection.emit(company);
    }
  }

  setAnySelection(data: any) {
    const id = companyId(data)
    this.setSelection(id)
    return id
  }

  private counter = {
    load: 0,
    notify: 0,
  }
  setAsynchSelection(id: number) {
    setTimeout(() => this.setSelection(id), 200)
  }

  setSelection(id: number) {
    console.log(`comp-sel->setSelection->1->${this.counter}`)
    const found = this.select.itemsList.items.find(value => {
      return value.value.id == id
    })
    if(found) {
      console.log(`comp-sel->setSelection->2->${this.counter}`)
      if(this.counter.load == 0) {
        this.counter.load++
        // setTimeout(() => {
          console.log(`comp-sel->XXXXXXXXXXXX->setSelection->${this.counter}`)
          this.select.select(found)
        // }, 100)
      }
      else
        this.select.select(found)
    }
    else
      this.select.clearModel()
  }


  get disabled(): boolean {
    return this.select.readonly
  }

  @Input() set disabled(value: boolean) {
    if(this.select) {
      this.select.readonly = value
    }
    this._readonly = value
  }
}

export interface CmpnSelection {
  id: number,
  company: any,
  counter: number
}